<div class="proxy-label-container">
  <span>{{ proxyText }}</span>
  
</div>